import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { WhyItFailedSection } from '../components/WhyItFailedSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { FooterSection } from '../components/FooterSection';
export function SalesPage() {
  useMetaPixel();
  return <div className="min-h-screen bg-cream-100 text-ink-900 font-lora selection:bg-amber-500/30" data-id="element-176">
      <HeroSection data-id="element-177" />
      <OpeningHookSection data-id="element-178" />
      <ProblemSection data-id="element-179" />
      <WhyItFailedSection data-id="element-180" />
      <MechanismSection data-id="element-181" />
      <WhatYouGetSection data-id="element-182" />
      <AudienceSection data-id="element-183" />
      <HowItWorksSection data-id="element-184" />
      <ProofSection data-id="element-185" />
      <FAQSection data-id="element-186" />
      <PricingSection data-id="element-187" />
      <FooterSection data-id="element-188" />
    </div>;
}